import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RxAutocompleteModule } from '@nrwl/rx-autocomplete';
import { RxCheckboxModule } from '@nrwl/rx-checkbox';
import { RxFormControlErrorsModule } from '@nrwl/rx-form-errors';
import { RxInputInternationalPhoneModule } from '@nrwl/rx-input-intl-phone';
import { RxInputModule } from '@nrwl/rx-input';
import { RxTextareaModule } from '@nrwl/rx-textarea';
import { RxListModule } from '@nrwl/rx-list';
import { RxReactiveFormCompositeComponent } from './rx-reactive-form-composite.component';
import { RxSelectModule } from '@nrwl/rx-select';
import { RxTipModule } from '@nrwl/rx-tip';
import { RxToggleModule } from '@nrwl/rx-toggle';
import { RxUiModule } from '@nrwl/rx-ui';
import { RxUploadThumbnailModule } from '@nrwl/rx-ui';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RxInputModule,
    RxCheckboxModule,
    RxTextareaModule,
    RxToggleModule,
    RxUiModule,
    RxListModule,
    RxSelectModule,
    RxAutocompleteModule,
    RxInputInternationalPhoneModule,
    RxTipModule,
    RxFormControlErrorsModule,
    RxUploadThumbnailModule,
    RxReactiveFormCompositeComponent,
  ],
  exports: [RxReactiveFormCompositeComponent],
})
export class RxReactiveFormCompositeModule {}
